import { styled } from '@material-ui/core';
import { Link } from 'react-router-dom';

const BlankLink = styled(Link)({
  textDecoration: 'none',
  color: 'inherit',
  '&.ellipsis': {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
});

export default BlankLink;
